import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import * as moment from 'moment';
import { Observable, filter, map, take } from 'rxjs';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import {
  ClubData,
  ClubDataLite,
  ClubGroup,
  ClubGroupPage,
  ClubList,
  ClubMembership,
  ClubMembershipExtended,
  ClubPos,
  ClubPosPage,
  ClubPosSale,
  CurrencyData,
  NewGameInfo,
  PlayerClubAccount,
  PlayerClubWalletBalance,
  PlayerClubWalletBalancePage,
  PlayerData,
  PlayerHomeInfo,
  PlayerInfo,
  PlayerList,
  TeeTimeBookingPlayer,
  TeeTimePriceCompDiscount,
  TeeTimePriceComponent,
  UserAuthentication,
} from 'src/data/mygolf.data';
import { createPlayerInfo, createPlayerList } from 'src/data/player-data';
import { JsonService } from 'src/json-util';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { FriendService } from 'src/providers/friend-service/friend-service';
import { PlayerService } from 'src/providers/player-service/player-service';
import { PlayerHomeDataService } from 'src/redux/player-home';
import { NewContactPage } from '../../new-contact/new-contact.page';
import { ClubService } from 'src/providers/club-service/club-service';
import { ClubInfo, createClubList } from 'src/data/club-course';
import { PosSalesListPage } from '../pos-sales-list/pos-sales-list.page';
export interface NonMg2uPlayer {
  playerName: string;
  email: string;
  gender: string;
}
export interface ObjectWithId {
  id?: string;
}
@Component({
  selector: 'app-item-list-management',
  templateUrl: './item-list-management.page.html',
  styleUrls: ['./item-list-management.page.scss'],
})
export class ItemListManagementPage implements OnInit {
  listMode: string = 'friends';
  searchQuery: string = '';
  searchPlayers: string = '';
  mode: string = 'new';
  membershipType: string;
  currencySymbol: string;
  _playerName: string;
  _email: string;
  _gender: string = 'M';
  _phone: string;
  _membershipNo: string;

  playerWallet: boolean = false;
  playerAccount: boolean = false;
  forOrder: boolean = true;
  infiniteComplete: boolean = false;
  fromClub: boolean;
  teeSlotNew: boolean = false;
  forBooking: boolean = false;
  registerThisPlayer: boolean = true;
  addThisMember: boolean = false;
  multiple: boolean = false;
  transferVoucher: boolean = false;

  clubId: number;
  maxPlayers: number;

  availablePlayers: Array<PlayerInfo> = [];
  pricingComponentsList: Array<TeeTimePriceComponent> = [];
  selectedPricingComponents: Array<TeeTimePriceComponent> = [];
  playersToExclude: Array<TeeTimeBookingPlayer> = [];
  players: Array<any> = [];
  clubMembers: Array<ClubMembership> = new Array<ClubMembership>();
  playerWalletList: Array<any> = new Array<any>();
  playerAccountList: Array<any> = new Array<any>();
  bookingPlayers: Array<TeeTimeBookingPlayer> =
    new Array<TeeTimeBookingPlayer>();
  clubSelectedPlayers: Array<PlayerInfo> = new Array<PlayerInfo>();
  friends: Array<PlayerInfo> = [];
  filteredClubMembership: Array<ClubMembershipExtended> = [];

  playerList: PlayerList;
  email: AbstractControl;
  playerName: AbstractControl;
  gender: AbstractControl;
  phone: AbstractControl;
  _newPlayer: PlayerInfo;
  addPlayerForm: FormGroup;
  public player$: Observable<PlayerInfo>;
  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  selectedOrderItems: any;
  openedModal: boolean = false;
  noNewPlayer: boolean = false;
  gameInfo: NewGameInfo;
  membersOnly: boolean = false;
  currency: CurrencyData;
  initTab: string = null;
  orderId: number;
  forPricingPlan: boolean = false;
  listFriends: PlayerList;
  currentPlayerId: number;


  headerTitle: string = 'Select Item';
  toggleSearch: boolean = false;
  groupClubsList: Array<ClubDataLite> = [];
  clubGroupId: string;
  productPackageList: Array<any> = [];
  selectedPackages: Array<any> = [];

  @Input() dataExtras: any;

  constructor(
    private flightService: ClubFlightService,
    private loadingCtrl: LoadingController,
    private playerService: PlayerService,
    private mg2uUtil: mygolfUtils,
    private platform: Platform,
    private toastCtl: ToastController,
    private modalCtl: ModalController,
    private keyboard: Keyboard,
    private navParams: NavParams,
    private fb: FormBuilder,
    private playerHomeService: PlayerHomeDataService,
    private friendService: FriendService,
    private alertCtrl: AlertController,
    private clubService: ClubService
  ) {
    this.openedModal = navParams.get('openedModal');
    let exclusion = navParams.get('playersToExclude');
    this.gameInfo = navParams.get('gameInfo');
    this.fromClub = navParams.get('fromClub');
    this.noNewPlayer = navParams.get('noNewPlayer');
    this.membershipType = navParams.get('membershipType');
    this.membersOnly = navParams.get('membersOnly');
    this.playerWallet = navParams.get('playerWallet');
    this.transferVoucher = navParams.get('transferVoucher');
    this.currency = navParams.get('currency');
    this.currencySymbol = navParams.get('currencySymbol');
    this.initTab = navParams.get('initTab');
    this.playerAccount = navParams.get('playerAccount');
    this.bookingPlayers = navParams.get('bookingPlayers');
    if (this.fromClub) this.clubId = navParams.get('clubId');
    this.multiple = navParams.get('multiple');
    this.selectedOrderItems = navParams.get('selectedOrderItems');
    this.selectedPricingComponents = navParams.get('selectedPricingComponents');
    this.mode = navParams.get('mode');
    this.orderId = navParams.get('orderId');
    this.forOrder = navParams.get('forOrder');
    this.forPricingPlan = navParams.get('forPricingPlan');

    console.debug('init selected order items : ', this.initTab);
    console.debug('init data extras : ', this.dataExtras);

    if (exclusion) {
      this.playersToExclude.push(...exclusion);
    }

    this.listFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      players: new Array<PlayerInfo>(),
    };
    this.addPlayerForm = this.fb.group({
      playerName: new FormControl('', [
        <any>Validators.required,
        <any>Validators.maxLength(50),
      ]),
      email: new FormControl('', [
        <any>Validators.required,
        <any>Validators.email,
        <any>Validators.maxLength(50),
      ]),
      gender: new FormControl('M'),
      phone: new FormControl('', [
        <any>Validators.required,
        Validators.minLength(7),
        <any>Validators.maxLength(50),
      ]),
    });

    this.playerName = this.addPlayerForm.controls['playerName'];
    this.email = this.addPlayerForm.controls['email'];
    this.gender = this.addPlayerForm.controls['gender'];
    this.phone = this.addPlayerForm.controls['phone'];

    if (this.fromClub) {
      this.listMode = 'others';
    } else {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        this.currentPlayerId = player.playerId;
      });
    }
    if (this.initTab) {
      this.listMode = this.initTab;
      if (this.listMode === 'members') this.refreshClubMembersList();
      else if (this.listMode === 'playerWallet') this.refreshPlayerWalletList();
    }
    if (this.membersOnly) {
      this.listMode = 'members';
      this.refreshClubMembersList();
    }
    // else if(!this.playerWallet && !this.membersOnly && this.fromClub) {
    //     this.listMode = 'members';
    //     this.refreshClubMembersList();
    // }
    else if (this.playerWallet) {
      this.listMode = 'playerWallet';
      this.refreshPlayerWalletList();
      this.getBulkMembershipPromise()
        .then((result: any) => {
          if (result) {
            if (result.status === 'success') {
              if (result.clubMembership)
                this.filteredClubMembership = result.clubMembership;
              else this.filteredClubMembership = [];
            } else this.filteredClubMembership = [];
          } else this.filteredClubMembership = [];
        })
        .catch((error) => { });
    } else if (this.playerAccount) {
      this.listMode = 'playerAccount';
      this.refreshPlayerAccountList();
      this.getBulkMembershipPromise()
        .then((result: any) => {
          if (result) {
            if (result.status === 'success') {
              if (result.clubMembership)
                this.filteredClubMembership = result.clubMembership;
              else this.filteredClubMembership = [];
            } else this.filteredClubMembership = [];
          } else this.filteredClubMembership = [];
        })
        .catch((error) => { });
    }

    //console.log("players to exclude : ", this.playersToExclude);
    this.playerList = createPlayerList();

    this.maxPlayers = this.navParams.get('maxPlayers');
    this.teeSlotNew = this.navParams.get('teeSlotNew');
    //console.log("add players - ", this.maxPlayers, this.teeSlotNew);
    this.clubSelectedPlayers.pop();
    this.forBooking = this.navParams.get('forBooking');
  }

  getBulkMembershipPromise() {
    // console.debug("get membershipnumber promise : ", playerId)

    let _clubMembership: Array<ClubMembershipExtended> = null;
    return new Promise((resolve, reject) => {
      if (
        this.listMode !== 'playerAccount' &&
        this.listMode !== 'playerWallet'
      ) {
        reject({
          status: 'failed',
          message: 'not account or wallet',
        });
      }
      let _playerIds = [];
      if (
        this.listMode === 'playerAccount' &&
        this.playerAccountList &&
        this.playerAccountList.length > 0
      ) {
        _playerIds = this.playerAccountList
          .filter((acc: PlayerClubAccount) => {
            return acc && acc.player;
          })
          .map((acc: PlayerClubAccount) => {
            return acc.player.id;
          });
      } else if (
        this.listMode === 'playerWallet' &&
        this.playerWalletList &&
        this.playerWalletList.length > 0
      ) {
        _playerIds = this.playerWalletList
          .filter((acc: PlayerClubWalletBalance) => {
            return acc && acc.player;
          })
          .map((acc: PlayerClubWalletBalance) => {
            return acc.player.id;
          });
      } else if (this.listMode === 'member') {
        this.clubMembers.forEach((cm: ClubMembershipExtended) => {
          _playerIds.push(cm.player.id);
        });
      }

      console.debug('bulk membership promise : ', _playerIds);
      let _clubId = this.clubId;
      let _params = {
        playerId: _playerIds,
        pageSize: 1000,
      };
      this.flightService.getFilteredClubMemberships(_clubId, _params).subscribe(
        async (data: any) => {
          // membershipList: Array<ClubMembership>
          console.debug('club membership list : [0]', data);
          // console.debug("club membership list : [1]", this.bookingSlot.clubData)
          if (data) {
            resolve({
              status: 'success',
              message: 'has membership',
              clubMembership: data.items,
            });
          } else {
            reject({
              status: 'failed',
              message: 'no club membership',
              clubMembership: null,
            });
          }
        },
        (error) => {
          reject({
            status: 'failed',
            message: 'no club membership',
            clubMembership: null,
          });
        },
        () => { }
      );
    });
  }

  clubList: ClubList;
  excludeClub: Array<any> = [];
  selectedClubs: Array<any> = [];
  ngOnInit() {

    if(!this.fromClub) {
      if (!this.listFriends.players.length)
      this._refreshValues();
      else {
      this._filterOnSearch();
      // if(this.listMode === 'member')
      if(this.fromClub) this.refreshClubMembersList();
      }
  }
  if(this.listMode === 'clubs') {
      this.toggleSearch = true;
      this.clubList    = createClubList();
      this._refreshClubs(null,null);
  } else if(this.listMode === 'clubGroups') {
      this.clubGroupList = [];
      this.onRefreshClubGroup();
  } else if(this.listMode === 'users') {
      this.userList = [];
      this.onRefreshUserList();
  } else if(this.listMode === 'groupClubs') {
      this.groupClubsList = [];
      this.onRefreshGroupClubList();
  } else if(this.listMode === 'userRoles') {
      // this.userRoles = [];
      // this.onRefreshUserRoles();
  } else if(this.listMode === 'partners') {
      this.partnerList = [];
      this.onRefreshPartnerList();
  } else if(this.listMode === 'productPackage') {
      // this.toggleSearch = true;
      // this.productPackageList = [];
      // this.onRefreshProductPackagesList();
  } else if(this.listMode === 'posCodes') {
    this.posCodesList = [];
    this.onRefreshClubPOSCodesList();
  } else {
      this.toggleSearch = true;
      this.getPricingComponents();
  }
   }

  ionViewWillEnter() {
    if (!this.fromClub) {
      if (!this.listFriends.players.length) this._refreshValues();
      else {
        this._filterOnSearch();
        // if(this.listMode === 'member')
        if (this.fromClub) this.refreshClubMembersList();
      }
    }
    this.getPricingComponents();
  }

  ionViewWillLeave() {
    //console.log("Leaving the view");
    if (this.platform.is('ios') || this.platform.is('capacitor'))
      this.keyboard.hide();
  }


  onRefresh() {
    if(this.listMode === 'clubs') {
        this.clubList    = createClubList();
        this._refreshClubs(null,null);
    } else if(this.listMode === 'clubGroups') {
        this.clubGroupList = [];
        this.onRefreshClubGroup();
    } else if(this.listMode === 'users') {
        this.userList = [];
        this.onRefreshUserList();
    } else if(this.listMode === 'groupClubs') {
        this.groupClubsList = [];
        this.onRefreshGroupClubList();
    } else if(this.listMode === 'userRoles') {
        this.userRoles = [];
        this.onRefreshUserRoles();
    } else if(this.listMode === 'partners') {
        this.partnerList = [];
        this.onRefreshPartnerList();
    } else if(this.listMode === 'productPackage') {
        this.productPackageList = [];
        this.onRefreshProductPackagesList();
    } else this.getPricingComponents()
}

  private async _refreshValues() {
    let busy = await this.loadingCtrl.create({
      message: 'Please wait...',
      duration: 5000,
    });
    busy.present().then(() => {
      this.friendService.searchFriends('', true).subscribe(
        (friendRequests: PlayerList) => {
          busy.dismiss().then(() => {
            this.listFriends.players = friendRequests.players.filter((p) => {
              let found = this.playersToExclude.filter((pl) => {
                if (pl.player) return pl.player.id === p.playerId;
              });
              return found.length === 0;
            });
            // this.gameInfo.
            this.availablePlayers = this.listFriends.players;
            // this._filterOnSearch();
            this.friends = this.listFriends.players;
            // if(this.searchQuery && this.searchQuery.length > 0) {
            //     this.listFriends.players = this.listFriends.players.filter((p: PlayerInfo)=>{
            //         if(p.playerName.toLowerCase().includes(this.searchQuery.toLowerCase()))
            //             return true
            //         if(p.email.toLowerCase().includes(this.searchQuery.toLowerCase()))
            //             return true
            //     })
            //     this.friends = this.listFriends.players
            //     this.availablePlayers = this.listFriends.players;
            // }
          });
        },
        (error) => {
          busy.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(
              error,
              'Error getting friend list'
            );
            MessageDisplayUtil.showErrorToast(
              msg,
              this.platform,
              this.toastCtl,
              5000,
              'bottom'
            );
          });
        }
      );
    });
  }

  private _filterOnSearch() {
    if (!this.searchQuery) this.friends = this.listFriends.players;
    else {
      this.friends = this.listFriends.players.filter((p: PlayerInfo) => {
        let name;
        let firstName;
        let lastName;
        if (!p) return false;
        // || !p.playerName || !p.firstName || !p.lastName
        if (p.playerName) name = p.playerName.toLowerCase();
        if (p.firstName) firstName = p.firstName.toLowerCase();
        if (p.lastName) lastName = p.lastName.toLowerCase();

        if (name && name.indexOf(this.searchQuery.toLowerCase()) >= 0)
          return true;
        else if (
          firstName &&
          firstName.indexOf(this.searchQuery.toLowerCase()) >= 0
        )
          return true;
        else if (
          lastName &&
          lastName.indexOf(this.searchQuery.toLowerCase()) >= 0
        )
          return true;
        else return false;
      });
    }
  }
  async newContact() {
    let newContactModal = await this.modalCtl.create({
      component: NewContactPage,
      componentProps: {
        openedAsDialog: true,
      },
    });
    newContactModal.onDidDismiss().then((data: any) => {
      //Check whether the club info is passed
      if (data) {
        this.playerSelected(null, data);
      }
    });
    newContactModal.present();
  }

  playerSelected(event, item: PlayerInfo) {
    if (this.openedModal) {
      this.modalCtl.dismiss(item);
    }
  }
  onSearchInput() {
    this.onRefresh();
    // this.getPricingComponents();
  }

  getPricingComponents() {
    let _clubId = this.clubId;
    let _params = {
      clubId: _clubId,
      active: 'Y',
      availableForOrder: this.forOrder ? 'Y' : 'N',
      search: this.searchQuery,
    };
    console.debug('get pricing components', this.clubId, _clubId, _params);
    this.flightService
      .listClubComponents(_clubId, _params)
      .subscribe((data) => {
        if (data) {
          this.pricingComponentsList = data;
          console.debug(
            'selected pricing components [order items]',
            this.selectedOrderItems,
            this.pricingComponentsList
          );
          if (
            0 &&
            this.mode === 'edit' &&
            this.selectedOrderItems &&
            this.selectedOrderItems.length > 0
          ) {
            console.debug(
              'selected pricing components',
              this.selectedOrderItems,
              this.pricingComponentsList
            );
            this.pricingComponentsList = this.pricingComponentsList.filter(
              (item) => {
                let _exists;
                this.selectedOrderItems
                  .filter((item2) => {
                    return item2.id === item.id;
                  })
                  .map((item) => (_exists = item));
                return !_exists || _exists.id !== item.id;
              }
            );
          }
          if (
            0 &&
            this.selectedPricingComponents &&
            this.selectedPricingComponents.length > 0
          ) {
            this.pricingComponentsList = this.pricingComponentsList.filter(
              (item) => {
                let _exists;
                this.selectedPricingComponents
                  .filter((item2) => {
                    return item2.id === item.id;
                  })
                  .map((item) => (_exists = item));
                return !_exists || _exists.id !== item.id;
              }
            );
          }
        }
      });
  }

  onSearchPricing(event, refresher) {
    this.getPricingComponents();
  }

  refreshClubMembersList(search?: string) {
    let _clubId = this.clubId;
    let _activeOnly = true;
    let _search = search ? search : this.searchPlayers;
    this.clubMembers = [];
    let _status = null;
    let _membershipTypes = [];
    if (this.membershipType && this.membershipType.length > 0)
      _membershipTypes.push(this.membershipType);
    let _params = {
      activeOnly: _activeOnly,
      search: _search,
      membershipTypes: _membershipTypes,
      //   status: _status,
    };
    console.debug(
      'refresh club membership : ',
      _membershipTypes,
      this.membershipType,
      _params
    );
    this.flightService
      .getClubMembersList(_clubId, _params)
      .subscribe((data: Array<ClubMembership>) => {
        //console.log(`club members : `, data)
        if (data && data.length > 0)
          this.clubMembers = data.filter((cm: ClubMembership) => {
            let _exclude;
            this.playersToExclude.filter((bp) => {
              if (bp.player.id === cm.player.id) _exclude = true;
            });
            return !_exclude;
          });
      });
  }
  onSearchById() {
    let _search = this.searchPlayers;
    let _letters = /[^0-9]/;
    //  /^[a-zA-Z]+$/;
    //console.log("search by id : ", _search, _letters, _search.match(_letters))
    if (_search.match(_letters)) {
      // if(typeof this.searchPlayers === 'string') {
      let msg = 'Please enter valid mg2u ID';
      MessageDisplayUtil.showErrorToast(
        msg,
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return false;
    }

    this.flightService
      .getPlayerById(Number(_search))
      .subscribe((response: any) => {
        let _data;
        if (response && response.status === 200) {
          _data = response;
          _data.playerId = _data.id;
          this.players.push(_data);
        }
        //console.log("get player by id ", response.json())
      });
  }
  getMembershipType(type?: string) {
    if (!type) return;
    let _membershipType = '';
    if (type === 'P') _membershipType = 'Privileged Guest';
    else if (type === 'T') _membershipType = 'Term Member';
    else if (type === 'F') _membershipType = 'Full Membership';
    else _membershipType = 'Full Membership';
    return _membershipType;
  }
  refreshPlayerWalletList(search?: string) {
    let _clubId = this.clubId;
    let _activeInactive = 'A';
    let _search = search ? search : this.searchPlayers;
    this.clubMembers = [];
    let _pageSize = 1000;
    let _status = null;
    let _membershipTypes = [];
    if (this.membershipType && this.membershipType.length > 0)
      _membershipTypes.push(this.membershipType);
    let _params = {
      activeOrInactive: _activeInactive,
      search: _search,
      membershipTypes: _membershipTypes,
      //   status: _status,
    };
    console.debug('refresh club wallet balances : ', _params);
    this.flightService
      .getClubWalletBalance(_clubId, _params)
      .subscribe((data: PlayerClubWalletBalancePage) => {
        if (data && data.items && data.items.length > 0) {
          this.playerWalletList = data.items.sort((a, b) => {
            if (
              a.player.playerName.toLowerCase() <
              b.player.playerName.toLowerCase()
            )
              return -1;
            else if (
              a.player.playerName.toLowerCase() >
              b.player.playerName.toLowerCase()
            )
              return 1;
            else return 0;
          });

          this.playerWalletList = this.playerWalletList.filter((item) => {
            return item.availableBalance > 0;
          });
          if (this.bookingPlayers && this.bookingPlayers.length > 0)
            if (this.playerWalletList && this.playerWalletList.length > 0)
              this.bookingPlayers.forEach((bp: TeeTimeBookingPlayer) => {
                this.playerWalletList = this.playerWalletList.filter((item) => {
                  if (bp.player)
                    return (
                      item.player &&
                      bp.player &&
                      item.player.id !== bp.player.id
                    );
                  else return true;
                });
              });
        }
      });
  }

  refreshPlayerAccountList(search?: string) {
    let _clubId = this.clubId;
    let _activeInactive = 'A';
    let _search = search ? search : this.searchPlayers;
    this.clubMembers = [];
    let _pageSize = 1000;
    let _pageNo = 1;
    let _status = null;
    let _membershipTypes = [];
    if (this.membershipType && this.membershipType.length > 0)
      _membershipTypes.push(this.membershipType);
    let _params = {
      withCreditLimit: 'Y', // Y, N, (B)oth
      search: _search,
      pageSize: _pageSize,
      pageNo: _pageNo,
      //   status: _status,
    };
    console.debug('refresh club accounts : ', _params);
    this.flightService
      .getClubAccountsList(_clubId, _params)
      .subscribe((data: PlayerClubWalletBalancePage) => {
        //console.log(`club wallet balance: `, data)
        if (data && data.items && data.items.length > 0) {
          this.playerAccountList = data.items.sort((a, b) => {
            if (
              a.player.playerName.toLowerCase() <
              b.player.playerName.toLowerCase()
            )
              return -1;
            else if (
              a.player.playerName.toLowerCase() >
              b.player.playerName.toLowerCase()
            )
              return 1;
            else return 0;
          });

          this.playerAccountList = this.playerAccountList.filter((item) => {
            return item.creditLimit + item.effectiveBalance > 0;
          });

          console.debug(
            'player account list : ',
            this.bookingPlayers,
            this.playerAccountList
          );

          // if(this.bookingPlayers.length > 0)
          if (this.playerAccountList && this.playerAccountList.length > 0)
            if (this.bookingPlayers && this.bookingPlayers.length > 0)
              this.bookingPlayers.forEach((bp: TeeTimeBookingPlayer) => {
                if (bp && bp.player)
                  this.playerAccountList = this.playerAccountList.filter(
                    (item) => {
                      return (
                        item.player &&
                        bp.player &&
                        item.player.id !== bp.player.id
                      );
                    }
                  );
              });
          console.debug(
            'player account list : ',
            this.bookingPlayers,
            this.playerAccountList
          );
        }
      });
  }

  async onSearchPlayers(refresher?, infinite?) {
    if (this.listMode === 'members') {
      this.refreshClubMembersList();
      return;
    } else if (this.listMode === 'playerWallet') {
      this.refreshPlayerWalletList();
      return;
    } else if (this.listMode === 'playerAccount') {
      this.refreshPlayerAccountList();
      return;
    }
    if (!infinite || !this.infiniteComplete) {
      this.playerList = createPlayerList();
      this.players = [];
    }
    if (!this.searchPlayers) this.players = [];
    else {
      let loader = await this.loadingCtrl.create({
        showBackdrop: false,
        duration: 5000,
        message: 'Searching for player...',
      });
      if (!infinite) this.players = [];

      loader.present().then(() => {
        let _search = this.searchPlayers;
        let _letters = /[0-9]/;
        //  /^[a-zA-Z]+$/;
        //console.log("search by id : ", _search, _letters, _search.match(_letters))
        if (_search.match(_letters) && !infinite) {
          this.flightService
            .getPlayerById(Number(_search))
            .subscribe((response: any) => {
              let _data;
              if (response && response.status === 200) {
                _data = response;
                _data.playerId = _data.id;
                JsonService.deriveFullUrl(_data, 'profile');
                JsonService.deriveFullUrl(_data, 'image');
                if (this.playersToExclude.length > 0) {
                  this.playersToExclude.find((pe) => {
                    if (pe && pe.player && pe.player.id === _data.id)
                      return false;
                    else this.players.unshift(_data);
                  });
                } else this.players.unshift(_data);
              }
              //console.log("get player by id ", response.json())
            });
          // if(typeof this.searchPlayers === 'string') {
          // let msg = 'Please enter valid mg2u ID';
          // MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
          // return false;
        }

        this.playerService
          .searchPlayers(
            this.searchPlayers,
            true,
            this.playerList.currentPage + 1
          )
          .subscribe(
            (playerList: PlayerList) => {
              loader.dismiss().then(() => {
                //console.log("search players ALL : ", playerList)
                if (playerList.totalPages > 0) this.playerList.currentPage++;

                if (playerList && playerList.players) {
                  let _players = playerList.players.filter((p) => {
                    let excluded = this.playersToExclude.find((pe) => {
                      if (pe && pe.player && pe.player.id && p && p.playerId)
                        return pe.player.id === p.playerId;
                      else return false;
                    });
                    let clubSelected = this.clubSelectedPlayers.find((cp) => {
                      if (cp.playerId === p.playerId) return true;
                      else return false;
                    });
                    return !excluded && !clubSelected;
                  });

                  this.playerList = playerList;
                  this.playerList.currentPage = playerList.currentPage;
                  this.playerList.totalPages = playerList.totalInPage;
                  this.playerList.totalItems = playerList.totalItems;
                  this.playerList.players.push(..._players);
                  this.players.push(..._players);
                }
              });
            },
            (error) => {
              loader.dismiss();
            },
            () => {
              if (infinite) {
                infinite.target.complete();
              }
            }
          );
      });
    }
  }

  friendSelected(item: PlayerInfo, etc?: any) {
    if (this.clubSelectedPlayers && this.clubSelectedPlayers.length > 0)
      return false;
    let _isNewPlayer = item ? false : true;
    console.debug('friend selected : ', etc);
    let _amount = 0;
    if (this.playerWallet) _amount = etc.availableBalance;
    else if (this.playerAccount) _amount = etc.creditLimit + etc.balanceAmount;
    this.modalCtl.dismiss({
      item: item,
      isCovid: true,
      newPlayer: _isNewPlayer,
      playerDetails: this.addPlayerForm.value,
      playerContact: '',
      availableBalance: _amount,
    });
  }

  getImage(item: any) {
    // PlayerInfo
    if (item.thumbnail) return item.thumbnail;
    else if (item.photoUrl) return item.photoUrl;
    else if (item.profile) return item.profile;
    else if (item.image) return item.image;
    else return '../../../../assets/image/default_user.png';
  }

  memberSelected(item: PlayerData, member?: ClubMembershipExtended) {
    if (this.clubSelectedPlayers && this.clubSelectedPlayers.length > 0)
      return false;
    let _isNewPlayer = item ? false : true;

    this.modalCtl.dismiss({
      item: item,
      isCovid: true,
      newPlayer: _isNewPlayer,
      playerDetails: this.addPlayerForm.value,
      playerContact: '',
      membershipDetails: member,
    });
  }

  getPlayerMembership(playerId: number, attribute?: string) {
    if (!playerId) return;
    let _membershipNumber: string = '';
    let _membershipTypeName: string = '';

    // console.debug("get player membership : ", playerId, this.filteredClubMembership)
    if (this.filteredClubMembership)
      this.filteredClubMembership
        .filter((cm) => {
          return cm && cm.player && cm.player.id === playerId;
        })
        .map((cm) => {
          _membershipNumber = '(' + cm.membershipNo + ')';
          _membershipTypeName = cm.membershipType.typeName;
        });
    if (attribute === 'typeName') return _membershipTypeName;
    else return _membershipNumber;
  }
  isBookingAgent() {
    return this.mg2uUtil.getUserType() === 'booking_agent';
  }
  excludeObjectsById<T extends ObjectWithId>(arr1: T[], arr2: T[]): T[] {
    if (!arr1) return;
    const excludedIds = new Set(arr2.map((obj) => obj.id));
    return arr1.filter((obj) => !excludedIds.has(obj.id));
  }
  onAddMulti(player: any) {
    if (this.clubSelectedPlayers.length >= this.maxPlayers) return false;
    if (this.listMode === 'others' && player) {
      this.clubSelectedPlayers.push(player);
      this.players = this.players.filter((p: PlayerInfo) => {
        return p.playerId !== player.playerId;
      });
    } else if (this.listMode === 'members' && player) {
      this.clubSelectedPlayers.push(player);
      this.clubMembers = this.clubMembers.filter((p: ClubMembership) => {
        return p.player.id !== player.id;
      });
    }
  }

  getPlayerWalletDetails(item: any, attribute: string) {
    switch (attribute) {
      case 'walletBalance':
        let _amount =
          this.currencySymbol +
          ' ' +
          this.mg2uUtil.numberWithCommas(item.availableBalance);
        return _amount;
      default:
        return;
    }
  }

  public isMore() {
    return (
      this.playerList.totalPages > 0 &&
      this.playerList.currentPage < this.playerList.totalPages
    );
  }

  doInfinite(infinite) {
    this.infiniteComplete = this.isMore();
    if (this.isMore()) {
      this.onSearchPlayers(null, infinite);
    } else {
      if (infinite) infinite.target.complete();
    }
  }

  getPlayerAccountDetails(item: any, attribute: string) {
    switch (attribute) {
      case 'accountBalance':
        let _total = item.creditLimit + item.effectiveBalance;
        let _amount =
          this.currencySymbol + ' ' + this.mg2uUtil.numberWithCommas(_total);
        if (_total < 0) return "<span style='color:red'>" + _amount + '</span>';
        else return _amount;
      default:
        return;
    }
  }

  async onKeySearchPlayerByEmail() {
    // let _valueChanged = this.email.valueChanges.pipe().debounceTime(1500).distinctUntilChanged();
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: 'Checking for existing player...',
    });

    if (this._email && this._email.length > 10) {
      let _email = this._email;
      this.flightService.getPlayerByEmail(_email).subscribe((data: any) => {
        loader.dismiss(data).then(() => {
          if (data.length > 0 && data[0]) {
            let _data = data[0];
            this._playerName =
              _data && _data.playerName ? _data.playerName : '';
            this._gender = _data && _data.gender ? _data.gender : 'M';
            this._phone =
              _data.addressInfo && _data.addressInfo.phone1
                ? _data.addressInfo.phone1
                : null;
            this._newPlayer = _data;
            MessageDisplayUtil.showErrorToast(
              'Player Found',
              this.platform,
              this.toastCtl,
              5000,
              'bottom'
            );
          } else this._newPlayer = createPlayerInfo();
        });
      });
    }
  }


  getProductList(exclude?: boolean) {
    let _filtered;
    if(exclude) {
        _filtered = this.pricingComponentsList.filter((item: TeeTimePriceComponent)=>{
            return !this.selectedOrderItems.some(i2 => i2.id === item.id)
        })
    } else {
        _filtered = this.pricingComponentsList;
    }
    console.debug("get product list : ", this.pricingComponentsList, this.selectedOrderItems, this.selectedPricingComponents);
    return _filtered;
}

  onSelectMultiple(comp: TeeTimePriceComponent) {
    let _idx = 0;
    this.pricingComponentsList
      .filter((type: TeeTimePriceComponent, idx) => {
        if (type.id === comp.id) {
          _idx = idx;
          return true;
        }
      })
      .map((type) => {
        if (this.selectedPricingComponents)
          this.selectedPricingComponents.push(type);
        else {
          this.selectedPricingComponents = [];
          this.selectedPricingComponents.push(type);
        }
      });
  }

  onSelectSingle(comp: TeeTimePriceCompDiscount) {
    this.modalCtl.dismiss(comp);

}
onSelectSingleProdPackage(prodPackage: any) {
    this.modalCtl.dismiss(prodPackage);
}

selectedProductPackages: Array<any> = [];
onSelectMultipleProdPackage(prodPackage: any) {
    let _idx = 0;
    console.debug(prodPackage, this.selectedProductPackages, this.productPackageList)
    this.productPackageList.filter((p, idx)=>{
        if(p.id === prodPackage.id) {
            _idx = idx;
            return true;
        }
    }).map((p)=>{
        if(this.selectedProductPackages)
            this.selectedProductPackages.push(p)
        else {
            this.selectedProductPackages = [];
            this.selectedProductPackages.push(p)
        }
    });
    // this.pricingComponentsList.splice(_idx,1)

}

  onSelectForMultiple() {
    // if (this.openedModal) {
    this.modalCtl.dismiss(this.selectedPricingComponents);
    // }
  }
  onDelete(chip: any, comp: TeeTimePriceComponent) {
    console.debug('delete chip', chip, comp);
    this.selectedPricingComponents = this.selectedPricingComponents.filter(
      (type) => {
        return type.id !== comp.id;
      }
    );
    setTimeout(() => {
      this.getPricingComponents();
    }, 1000);
  }

  onDeleteProdPackage(chip: Element, prodPackage: any) {
    console.debug('delete chip', chip, prodPackage)
    this.selectedProductPackages = this.selectedProductPackages.filter((p)=>{
        return p.id !== prodPackage.id
    })
    setTimeout(()=>{
        this.onRefreshProductPackagesList()
    },1000)


}

  onRemoveMulti(player) {
    console.debug('on remove multi : ', player, this.clubSelectedPlayers);
    if (!player) return;
    let _index = this.clubSelectedPlayers.findIndex((p) => {
      return p && player && p.playerId === player.playerId;
    });
    this.clubSelectedPlayers.splice(_index, 1);
    this.onSearchPlayers();
  }

  getClubSelectedPlayers() {
    let _playersList = '';
    this.clubSelectedPlayers.forEach((p: PlayerInfo, idx: number) => {
      //console.log("club player select - ", idx, p)
      // if(idx > 0)
      _playersList += p.playerName + ', ';
    });
    return _playersList; //.slice(0,-1);// .substring(0,_playersList.length-1);
  }

  clearClubSelectedPlayers() {
    this.clubSelectedPlayers.pop();
    this.onSearchPlayers();
  }

  addMultiPlayers() {
    if (this.clubSelectedPlayers && this.clubSelectedPlayers.length === 0)
      return false;
    // let item = this._newPlayer?this._newPlayer.playerName?this._newPlayer:null:null;
    // let _isNewPlayer = item?false:true;
    this.modalCtl.dismiss({
      item: this.clubSelectedPlayers,
      isCovid: true,
      newPlayer: false,
      playerDetails: {},
      playerContact: '',
      multiPlayers: true,
    });
  }

  addOrderItem(items, x) {
    return new Promise((resolve, reject) => {
      let _addedOn = moment().format('YYYY-MM-DD HH:mm:ss');
      let _params = {
        componentId: items[x],
        description: null, //'Added on ' + _addedOn,
        itemCount: 1,
      };
      this.flightService
        .addOrderItems(this.clubId, this.orderId, _params)
        .subscribe(
          (data) => {
            if (data) {
              if (items && x <= items.length) {
                resolve({
                  done: false,
                  data: data,
                  count: x,
                });
              } else {
                resolve({
                  done: true,
                  data: data,
                  count: x,
                });
              }
            }
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  onProcessAddItem(items, x) {
    this.addOrderItem(items, x)
      .then((res: any) => {
        if (res) {
          // if(arr.length === idx+1) {
          if (res.done || res.count === items.length - 1) {
            this.modalCtl.dismiss({
              success: true,
              orderDetails: res,
            });
          } else this.onProcessAddItem(items, x + 1);

          // }
        }
      })
      .catch((error) => {
        let _error = error;
        let _msg = _error.errorMessage;
        MessageDisplayUtil.showErrorToast(
          _msg,
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      });
  }

  onClickAddItems() {

    let _items = [];
    let _packages = [];

    if(this.selectedPricingComponents && this.selectedPricingComponents.length > 0) {
        this.selectedPricingComponents.forEach((type: TeeTimePriceComponent)=>{
            _items.push(type.id)
        })
    }

    if(this.selectedProductPackages && this.selectedProductPackages.length > 0) {
        this.selectedProductPackages.forEach((p: any)=>{
            _packages.push(p.id)
        })
    }

    console.debug('add items', this.selectedPricingComponents, _items, this.mode);
    if(this.mode === 'edit' && this.listMode === 'others') {
        let x = 0;
        this.onProcessAddItem(_items,x)
        // _items.forEach((item, idx, arr)=>{

        // })

    } else if(this.mode === 'edit' && this.listMode === 'productPackage') {
        let x = 0;
        // this.onProcessAddItem(_items,x)
        // _items.forEach((item, idx, arr)=>{

        // })

    } else {
        let _params = {
            items: _items,
            packages: _packages,
        }
        this.flightService.addClubOrder(this.clubId, _params)
        .subscribe((data)=>{
            if(data) {
                this.modalCtl.dismiss({
                    success: true,
                    orderDetails: data
                });
            }
        })
    }
  }

  addMeself() {
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      this.modalCtl.dismiss({
        item: player,
        isCovid: true,
        newPlayer: false,
        playerDetails: '', //this.addPlayerForm.value,
        playerContact: '', //playerContact
      });
    });
  }
  async _additionalForm(item?: PlayerInfo) {
    let _isNewPlayer = item ? false : true;
    //console.log("is New Player?", _isNewPlayer)
    // <h3 style="color:red">COVID-19 Important Notice</h3>
    let _message = `<img item-left src="assets/img/booking-item-covid.svg" style="float:left;width: 4em;margin: 0.5em;" />

    <h4 item-right style="color:red;white-space: normal;">MGA recommends that all players should include their
        addresses for contact tracing</h4>`;
    let alert = await this.alertCtrl.create({
      header: 'COVID-19 Important Notice',
      // subTitle: 'Selected date is '+ _date,
      message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
      // buttons: ['Close']
      inputs: [
        {
          name: 'playerContact',
          placeholder: 'Enter address',
        },
      ],
      buttons: [
        {
          text: 'Proceed',
          // role: 'cancel',
          handler: (playerContact) => {
            //console.log("saving playerContact ", playerContact)
            this.modalCtl.dismiss({
              item: item,
              isCovid: true,
              newPlayer: _isNewPlayer,
              playerDetails: this.addPlayerForm.value,
              playerContact: playerContact,
            });
            // this.nav.push(BookingHomePage, {
            //     fromBookNow: true
            // })
            // console.log('Cancel clicked');
          },
        },
      ],
    });
    alert.present();

    // let newContactModal = this.modalCtl.create(NewContactPage, {
    //     openedAsDialog: true
    // });
    // newContactModal.onDidDismiss((data: PlayerInfo) => {
    //     //Check whether the club info is passed
    //     if (data) {
    //         this.playerSelected(null, data);
    //     }
    // });
    // newContactModal.present();
  }
  addPlayer() {
    if (this.registerThisPlayer) {
      if (
        !this._email ||
        !this._playerName ||
        this._email.length === 0 ||
        this._playerName.length === 0
      ) {
        MessageDisplayUtil.showErrorToast(
          'Please fill-in Player Name and Email Address',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
      // console.debug("register this player : ", this._email, this.emailIsValid(this._email))
      if (!this.emailIsValid(this._email)) {
        MessageDisplayUtil.showErrorToast(
          'Please use valid Email Address',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
      if (this.addThisMember) {
        if (!this._membershipNo || this._membershipNo.length === 0) {
          MessageDisplayUtil.showErrorToast(
            'Please fill-in Club Membership Number',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          return false;
        }
      }
    } else if (!this.registerThisPlayer) {
      if (!this._playerName || this._playerName.length === 0) {
        MessageDisplayUtil.showErrorToast(
          'Please fill-in Player Name',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
    }
    let item = this._newPlayer
      ? this._newPlayer.playerName
        ? this._newPlayer
        : null
      : null;
    let _isNewPlayer = item ? false : true;
    this.modalCtl.dismiss({
      item: item,
      isCovid: true,
      newPlayer: _isNewPlayer,
      // playerDetails: this.addPlayerForm.value,
      playerDetails: {
        email: this._email,
        playerName: this._playerName,
        gender: this._gender,
        phone: this._phone,
        membershipNo: this._membershipNo,
      },
      playerContact: '', //playerContact
      registerThisPlayer: this.registerThisPlayer,
      addThisMember: this.addThisMember,
    });
  }

  emailIsValid(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  }

  close() {
    this.modalCtl.dismiss();
  }


  partnerList: Array<any>;
  selectedPartners: Array<any>;
  onRefreshPartnerList() {
      let _params = {
          country: null,
          search: null,
          pageSize: 30,
          pageNo: null,
          partnerServices: ['BOOKING_AGENT']
      }
      this.flightService.getPartnerList(_params)
      .subscribe((data)=>{
          if(data) {
              this.partnerList = data.items;
              this.partnerList.forEach((partner)=>{
                  JsonService.deriveFulImageURL(partner, 'partnerImage')
              })
          }
      })
  }
  getFilteredPartners(service?: string) {
      if(!this.partnerList) return [];
      if(this.partnerList.length === 0) return [];
      let _filtered;
      _filtered = this.partnerList.filter((partner)=>{
          if(this.selectedPartners && this.selectedPartners.length > 0)
              return this.selectedPartners.some((p)=>{ return p.id === partner.id})
          else return true
      })
      return _filtered;
  }

  currentPage: number = 1;
  totalPages: number = 1;
  userList: Array<UserAuthentication> = [];
  onRefreshUserList(page: number = 1, infinite?: any) {
    let _params = {
        pageSize: 30,
        pageNo: page,
        search: this.searchQuery.trim(),

    };
    if(!infinite) {
        this.userList = [];
        this.currentPage = 1;
        this.totalPages = 1;
    }
    this.flightService.getUsersList(_params)
    .subscribe((data)=>{
        if(data && data.totalItems > 0) {
            this.userList.push(...data.items);
            this.currentPage = data.currentPage;
            this.totalPages = data.totalPages;
            this.userList.forEach((user)=>{
                JsonService.deriveFulImageURL(user.profile, 'photo', 'img/default_user.png');
            })
            // this.currentPage = data.currentPage;
            // this.totalPages = data.totalPages;
        }
    },(error)=>{

    },()=>{
        if (infinite) {
            infinite.complete();
        }
    })
}

onClickUser(user: UserAuthentication) {
    this.modalCtl.dismiss({
        success: true,
        user: user,
    })

}

  onClickPartner(partner: any) {
    this.modalCtl.dismiss({
        success: true,
        partner: partner,
    });
  }

  onRefreshGroupClubList() {
    let _groupId = this.clubGroupId;
    this.groupClubsList = [];
    this.flightService.getClubGroupDetails(_groupId)
    .subscribe((data)=>{
        if(data && data.clubs && data.clubs.length > 0) {
            this.groupClubsList = data.clubs;
            this.groupClubsList.forEach((club) => {
                JsonService.deriveFulImageURL(club,'clubImage','img/default_club.png');
            })
            this.groupClubsList.sort((a: ClubDataLite,b: ClubDataLite) =>{
                if(a.clubName < b.clubName) return -1;
                else if(a.clubName > b.clubName) return 1;
                else return 0
            })

        }
    })
}

getUserDetails(user, attribute?: string) {
    if(!user) return;

    switch(attribute) {
        case 'roles':
            if(!user.roles) return '';
            if(user.roles.length === 0) return '';
            return user.roles.map((role) => { return role.role.name}).join(', ');
        case 'name':
            return user.name;
        case 'photo':
            if(!user.profile) return '';
            if(!user.profile.photo) return ;
            return user.profile.photo;

    }
}

userRoles: Array<any>;
selectedRoles: Array<any>;
onRefreshUserRoles() {
    this.flightService.getUserRolesList()
    .subscribe((data)=>{
        if(data) {
            this.userRoles = data;
            this.userRoles.forEach((r)=>{
                if(this.selectedRoles.some((sr)=> sr.role && sr.role.id === r.id)) {
                    r.checked = true;
                } else {
                    r.checked = false;
                }
            })
        }
    })
}

getFilteredRoles() {
    if(!this.userRoles) return [];
    if(this.userRoles.length === 0) return [];
    let _filtered = this.userRoles.filter((r)=>{
        if(r.id === 'ROLE_BRITESOFT' || r.id === 'ROLE_SUPER_ADMIN' || r.id === 'ROLE_CLUB_GROUP' || r.id === 'ROLE_CLUB'
        || r.id === 'ROLE_PARTNER') return false;
        else return true;
    })
    return _filtered;
}

onClickSetRoles() {
    this.modalCtl.dismiss({
        success: true,
        roles: this.userRoles,
    })
}



getFilteredClubs() {
    let _filtered = [];
    if(!this.clubList.clubs) return _filtered;
    if(this.clubList.clubs.length === 0) return _filtered;

    _filtered = this.clubList.clubs.filter((c)=>{
        if(this.selectedClubs && this.selectedClubs.length > 0)
            return !(this.selectedClubs.some((sc)=>{ return sc.clubId === c.clubId}))
        else return true
    })
    return _filtered;
}

onRefreshProductPackagesList() {
    let _clubId = this.clubId;
    let _params = {
        search: this.searchQuery,
    }
    this.flightService.getProductPackagesList(_clubId, _params)
    .subscribe((data)=>{
        if(data) {
            this.productPackageList = data;
        }
    })
}

getProductPackageList(exclude?: boolean) {
    let _filtered = [];
    console.debug("getProductPackageList : ", this.productPackageList, this.selectedPackages);

    if(this.productPackageList && this.productPackageList.length > 0) {
        if(this.selectedPackages && this.selectedPackages.length > 0) {
            _filtered = this.productPackageList.filter((p)=>{
                return !this.selectedPackages.some((sp)=>{ return sp.packageName && sp.packageName.toLowerCase() === p.name.toLowerCase() })
            })
        } else _filtered = this.productPackageList;
    }

    if(exclude) {
        _filtered = _filtered.filter((p)=>{
            return !this.selectedProductPackages.some((sp)=>{ return sp.id === p.id })
        })
    }

    return _filtered;
    }


  private _refreshClubs(refresher, infinite) {
      // let busy = this.loadCtl.create({
      //     content: "Please wait..."
      // });
      // busy.present().then(()=>{
          let _pageSize = 500;
          let _countryId = null; //this.countryId
          // _pageSize
      this.clubService.searchClubs(this.searchQuery, true, this.clubList.currentPage + 1, _countryId)
          .subscribe((clubList: ClubList) => {
              // busy.dismiss().then(()=>{
              this.clubList.currentPage = clubList.currentPage;
              this.clubList.totalPages  = clubList.totalInPage;
              this.clubList.totalItems  = clubList.totalItems;
              this.clubList.clubs.push(...clubList.clubs);
              // if(!this.forMembership) this._filterVirtualClubs();
              if(this.selectedClubs) {
                  console.debug("excluded club : ", this.selectedClubs, this.clubList.clubs);
                  this.clubList.clubs = this.clubList.clubs.filter((c)=>{
                      return this.selectedClubs.indexOf(c.clubId) === -1;
                  });
              }

              // });

          }, (error) => {
              // busy.dismiss().then(()=>{
              let msg = MessageDisplayUtil.getErrorMessage(error, "Error getting club list");
              MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
              // })
          }, () => {
              //Handle the refresher or infinite
              if (refresher && refresher.complete) refresher.complete();
              if (infinite) {
                  if (infinite.complete) infinite.complete();
                  if (this.isMore()) {
                      infinite.enable(true);
                  }
                  else infinite.enable(false);
              }
              // if (this.platform.is('ios') || this.platform.is('cordova'))
              //     this.keyboard.close();
          });
      // });

  }

  isMoreClub(): boolean {
      return this.clubList && this.clubList.totalPages > 0
          && this.clubList.currentPage < this.clubList.totalPages;
  }

  doInfiniteClub(infinite) {
      console.log("Current Page = " + this.clubList.currentPage);
      if (this.isMoreClub()) {
          this._refreshClubs(null, infinite);
      }

  }

  // private _filterVirtualClubs() {
  //     if(this.clubList.clubs.length > 0) {
  //         this.clubList.clubs = this.clubList.clubs.filter((x: ClubInfo) => {
  //             return !x.virtualClub
  //         })
  //         console.log("[Club] Club List filtered : ",this.clubList)
  //     }
  // }


  // private _clearItems() {
  //     this.clubList = createClubList();
  // }


  onSelectMultipleClub(club: ClubInfo) {
      let _idx = 0;
      // console.debug(comp, this.trxnTypesList, this.selectedTrxnTypes)
      this.clubList.clubs.filter((c: ClubInfo, idx)=>{
          if(c.clubId === club.clubId) {
              _idx = idx;
              return true;
          }
      }).map((c, idx)=>{
          if(this.selectedClubs)
              this.selectedClubs.push(c)
          else {
              this.selectedClubs = [];
              this.selectedClubs.push(c)
          }
          // this.clubList.clubs.splice(idx, 1);
      });

  }


  clubsToRemove: Array<ClubInfo> = [];
  onDeleteClub(chip: Element, club: ClubInfo) {
      console.debug('delete club', chip, club)
      this.selectedClubs = this.selectedClubs.filter((c)=>{
          return c.clubId !== club.clubId
      })
      this.clubsToRemove.push(club)

      setTimeout(()=>{
          this._refreshClubs(null, null)
      },1000)


  }

  clubGroupList: Array<ClubGroup> = new Array<ClubGroup>();
  onRefreshClubGroup() {
      let _params = {
          search: '',
          pageSize: null,
          pageNo: 1
      };
      this.flightService.getClubGroups(_params)
      .subscribe((clubGroupPage: ClubGroupPage) =>{
          this.clubGroupList = [];
          if(clubGroupPage && clubGroupPage.totalItems > 0)
              this.clubGroupList = clubGroupPage.items;
              // clubGroupPage.items.forEach((group: ClubGroup, idx, arr)=>{
              //     this.getClubGroupDetails(group.id)
              //     .then((result: any)=>{
              //         if(result && result.status === 'success') {
              //             arr[idx] = result.clubGroup
              //         }
              //     })
              // });
      }, (error) => {
              let msg = MessageDisplayUtil.getErrorMessage(error, "Error getting club list");
              MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
          }, () => {
              // //Handle the refresher or infinite
              // if (refresher && refresher.complete) refresher.complete();
              // if (infinite) {
              //     if (infinite.complete) infinite.complete();
              //     if (this.isMore()) {
              //         infinite.enable(true);
              //     }
              //     else infinite.enable(false);
              // }
              // if (this.platform.is('ios') || this.platform.is('cordova'))
              //     this.keyboard.close();
          });
      // });
  }

  onClickClubGroup(group: ClubGroup) {
      this.modalCtl.dismiss({
          success: true,
          selectedGroup: group,
      });
  }

  onClickClub(club: ClubDataLite | ClubData) {

      this.modalCtl.dismiss(club);
  }


  onClickAddClubs() {
    this.modalCtl.dismiss({
        success: true,
        clubs: this.selectedClubs,
        clubsToRemove: this.clubsToRemove,
    })

}

posCodesList: Array<ClubPos> = [];
onRefreshClubPOSCodesList() {
  let _params = {
    clubId: this.clubId,
    pageSize: 100
  }
  this.flightService.listPOSCodes(_params)
  .subscribe((posSalesPage: ClubPosPage)=>{
    if(posSalesPage?.totalItems > 0) {
      this.posCodesList = posSalesPage.items;
    }
  })
}

onClickPosCode(clubPos: ClubPos) {
  this.modalCtl.dismiss(clubPos);
}

}
